import React from 'react';
import classes from '../InviteUsersModal.module.scss';
import { useTranslation } from 'react-i18next';
import { Collapse, Tooltip } from 'antd';
import RowLoader from 'components/Sceletons/RowLoader';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useAppSelector } from 'store/hook';
import { IGroup } from 'interfaces';
import { allPermissions } from 'helpers/createPermissionTableData';

type CollapsedItemsType = {
  group: IGroup;
  currentPermissions: string[] | undefined;
  currentFolderPermissions: any;
  isLoadingPermissionsByFolders: boolean;
  requestingFolderKey: string
};

const CollapsedItems = ({
  group,
  currentPermissions,
  currentFolderPermissions,
  isLoadingPermissionsByFolders,
  requestingFolderKey,
}: CollapsedItemsType) => {
  const { rolesPermissions } = useAppSelector((state) => state.dataUsers);
   const { userFoldersPermissions, userRootPermissions } = useAppSelector((state) => state.permissions);

  const fakeArrOfRoomsFodlers = userFoldersPermissions ? [...userFoldersPermissions, userRootPermissions] : [userRootPermissions];

  const { t } = useTranslation();  
  
  const statusIcons = {
    true: <CheckOutlined style={{color: 'green', paddingRight: 10, fontSize: 16}}/>,
    false: <CloseOutlined style={{color: 'red', paddingRight: 10, fontSize: 16}}/>,
    undefined: <CloseOutlined style={{color: 'red', paddingRight: 10, fontSize: 16}}/>
  };

  return (
    <div className={classes.premissionsWrap}>
      <div className={classes.premissionsDescription}>{t('Users.modals.invite.mainPermissions')}</div>
      <Collapse
        expandIconPlacement={'end'}
        bordered={false}
        size='small'
        items={[{
          key: 'general',
          label: t('Users.modals.invite.general'),
          extra: `${currentPermissions?.filter((permission) => permission !== 'can_edit_user_group')?.length}/${rolesPermissions?.length}`,
          children: <div className={classes.groupPermissions}>{
            rolesPermissions?.map((permission: any) => (
              <div key={permission.id}>
                <Tooltip title={permission.description}>
                  {statusIcons[String(currentPermissions?.includes(permission.type)) as keyof typeof statusIcons]}
                  {permission.name}
                </Tooltip>
              </div>
            ))
          }</div>,
        }]}
      />
    
      <div className={classes.premissionsDescription}>{t('Users.modals.invite.foldersPermissions')}</div>
    
      { (isLoadingPermissionsByFolders && requestingFolderKey === group.id)
        ? fakeArrOfRoomsFodlers?.map((el: any) => <RowLoader key={el.id} width='100%' padding='0 8px 0 8px' height='32px' />)
        : currentFolderPermissions?.map((folder: any, i: number) => i !== 0 && (
          <Collapse
            expandIconPlacement={'end'}
            className={classes.folderPermissions}
            key={folder.id}
            bordered={false}
            size='small'
            items={[{
              key: folder.id,
              label: <div className={classes.folderName}>{folder.id === 0 ? t('Documents.modals.rootDir') : folder.name}</div>,
              extra: `${folder?.permissions?.length || 0}/${allPermissions?.length}`,
              children: <div className={classes.groupPermissions}>{allPermissions?.map((permission) => (
                <div key={permission}>
                  <div style={{display: 'flex'}}>
                    {statusIcons[String(folder?.permissions?.includes(permission)) as keyof typeof statusIcons]}
                    <span className={classes.firstUpper}>{t(`Logs.logsModal.${permission}`)}</span>
                  </div>
                </div>
              ))}</div>,
            }]}
          />
        ))
      }
    </div>
  );
}

export default CollapsedItems;
